/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    AvailableOfferVintageDto,
    BottleDto,
    BuyerOffersDto,
    OfferCreationRequestDto,
    OfferInfoDto,
    PageOfferInfoSearchResultDto,
    WineBoxFullSummaryDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class OfferControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        acceptOffer(
                    offerId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/instance/${offerId}/accept`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        createOffer(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: OfferCreationRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/offer/instance`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getAvailableBottlesForOffer(
                
                queryParams: {
                    ownerType: string,
                    ownerId: number,
                    inBox?: boolean,
                    userLegalEntityId?: number
                }
    ): Observable<Array<BottleDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/bottles`;

            return this._httpClient.get<Array<BottleDto>>(url, requestOptions);
    }


        getAvailableBoxesForOffer(
                
                queryParams: {
                    ownerType: string,
                    ownerId: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<WineBoxFullSummaryDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/boxes`;

            return this._httpClient.get<Array<WineBoxFullSummaryDto>>(url, requestOptions);
    }


        getAvailableVintagesForOffer(
                
                queryParams: {
                    ownerType: string,
                    ownerId: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<AvailableOfferVintageDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/vintages`;

            return this._httpClient.get<Array<AvailableOfferVintageDto>>(url, requestOptions);
    }


        getBuyerOffers(
                    offerId: number
                , 
                queryParams: {
                    buyerOwnerType?: string,
                    buyerOwnerId?: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<BuyerOffersDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/instance/${offerId}/buyers`;

            return this._httpClient.get<Array<BuyerOffersDto>>(url, requestOptions);
    }


        getOffer(
                    offerId: number
    ): Observable<OfferInfoDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/instance/${offerId}`;

            return this._httpClient.get<OfferInfoDto>(url, requestOptions);
    }


        getOfferPage(
                
                queryParams: {
                    ownerUserId?: number,
                    ownerOrgUnitId?: number,
                    buyerUserId?: number,
                    buyerOrgUnitId?: number,
                    statuses?: Array<string>,
                    offerTypes?: Array<string>,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageOfferInfoSearchResultDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/page`;

            return this._httpClient.get<PageOfferInfoSearchResultDto>(url, requestOptions);
    }


        rejectOffer(
                    offerId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/offer/instance/${offerId}/reject`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


}

